import { apolloClient } from '~/apollo-client';
import { Flex_FetchUtilityQuery, Flex_FetchUtilityQueryVariables } from '~/typings/graphql';
import { FETCH_UTILITY } from './fetch-utility.queries';

export type FetchUtilityParams = {
  utilityId: number;
};

export type FetchUtilityResponse = Flex_FetchUtilityQuery['utility'];

export const fetchUtility = async (params: FetchUtilityParams): Promise<FetchUtilityResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchUtilityQuery,
    Flex_FetchUtilityQueryVariables
  >({
    query: FETCH_UTILITY,
    variables: {
      utilityId: params.utilityId,
    },
  });

  return data.utility;
};
